module.exports = __webpack_public_path__ + "img/79.1d1b5732.jpg";